import { AnalyticsV3ContextActions, AnalyticsV3ContextType, ResponseMetricsType } from './types';
import { StateCreator, StoreApi as ZustandStoreApi } from 'zustand';
import { initialFilters, onCallUserPerHourinitialFilters, defaultDateRange } from '../constants';

const getFiltersFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const filters = JSON.parse(atob(params.get('filters') || btoa(JSON.stringify(initialFilters))));
    return filters;
  } catch (error) {
    return initialFilters;
  }
};

const getOnCallFiltersFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const filters = JSON.parse(
      atob(
        params.get('onCallUserPerHourFilters') ||
          btoa(JSON.stringify(onCallUserPerHourinitialFilters)),
      ),
    );
    return filters;
  } catch (error) {
    return onCallUserPerHourinitialFilters;
  }
};

export const urlMiddleware =
  (config: StateCreator<AnalyticsV3ContextType & AnalyticsV3ContextActions>) =>
  (
    set: (state: Partial<AnalyticsV3ContextType & AnalyticsV3ContextActions>) => void,
    get: () => AnalyticsV3ContextType & AnalyticsV3ContextActions,
    api: ZustandStoreApi<AnalyticsV3ContextType & AnalyticsV3ContextActions>,
  ) => {
    // Get initial state from URL params
    const params = new URLSearchParams(window.location.search);
    const isFilterDrawerOpen = params.get('isFilterDrawerOpen') || 'false';
    const tabIndex = params.get('tabIndex') || '1';
    const responseMetricType = params.get('responseMetricType') || 'mean';
    const filters = getFiltersFromUrl();
    const onCallUserPerHourFilters = getOnCallFiltersFromUrl();
    const urlTimeZone = params.get('timezone');
    const timezone = urlTimeZone || defaultDateRange.timeZone;
    const startDate = params.get('startDate') || defaultDateRange.startDate.toISOString();
    const endDate = params.get('endDate') || defaultDateRange.endDate.toISOString();
    // Create store with URL-synced initial state
    const store = config(
      (state: Partial<AnalyticsV3ContextType & AnalyticsV3ContextActions>) => {
        set(state);

        // Update URL whenever state changes
        const currentState = get();
        const searchParams = new URLSearchParams();
        searchParams.set('isFilterDrawerOpen', currentState.isFilterDrawerOpen.toString());
        searchParams.set('tabIndex', currentState.tabIndex.toString());
        searchParams.set('responseMetricType', currentState.responseMetrics.metricType);
        searchParams.set('filters', btoa(JSON.stringify(currentState.filters)));
        searchParams.set(
          'onCallUserPerHourFilters',
          btoa(JSON.stringify(currentState.onCallUsersFilter)),
        );
        searchParams.set('timezone', currentState.dateRange.timeZone);
        searchParams.set('startDate', currentState.dateRange.startDate.toISOString());
        searchParams.set('endDate', currentState.dateRange.endDate.toISOString());
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;

        window.history.replaceState(null, '', newUrl);
      },
      get,
      api,
    );

    const currentState = get() ?? {};

    return {
      ...store,
      isFilterDrawerOpen: isFilterDrawerOpen === 'true',
      tabIndex: parseInt(tabIndex),
      responseMetrics: {
        ...(currentState?.responseMetrics ?? {}),
        metricType: responseMetricType as ResponseMetricsType,
      },
      filters,
      onCallUserPerHourFilters,
      dateRange: {
        ...(currentState?.dateRange ?? {}),
        timeZone: timezone,
        startDate: new Date(startDate),
        endDate: new Date(endDate),
      },
    };
  };
